// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__11aGq","right":"styles_right__3xHgS"};